import styles from './Changes.module.css';
import Change from './Change.jsx';

const Changes = (props) => {
    const sortByOrder = (a, b) => {
		if(a.created_at > b.created_at){
			return -1;
		}
		else if(a.created_at < b.created_at){
			return 1;
		}
		return 0;
    };

	return (
		<div className={props.className} style={props.style}>
            <div className={styles.topRow}>
                <h2 className={styles.header}>
                    Changes ({props.changes.length})
                </h2>
            </div>
            {
                props.changes.length > 0 && (
                    <div className={styles.changesContainer}>
                        <div className={styles.changes}>
                            {
                                props.changes.sort(sortByOrder).map((change, index) => (
                                    <Change className={styles.change} change={change} index={index} setShowViewDescriptionModal={props.setShowViewDescriptionModal}
                                            setViewDescriptionText={props.setViewDescriptionText} key={'change-' + change.id}/>
                                ))
                            }
                        </div>
                    </div>
                )
            }
        </div>
    )
};

export default Changes;